import { useMemo, useSyncExternalStore } from "react";
import ResponsiveObserve, { ScreenMap } from "../_utils/responsiveObserve";

function useBreakpoint(): ScreenMap & {
  isMobile: boolean;
  isMobileAndMd: boolean;
  isMobileAndLg: boolean;
  devicePixelRatio: number;
} {
  // HYDRATION-FIX: `useSyncExternalStore` lit matchMedia au 1er render client
  // (pas après useEffect) — évite le switch hero/widgets post-hydratation.
  const screens = useSyncExternalStore(
    (onStoreChange) => ResponsiveObserve.subscribeStore(onStoreChange),
    () => ResponsiveObserve.getSnapshot(),
    () => ResponsiveObserve.getServerSnapshot()
  );

  const isMobile: boolean = useMemo(() => {
    return !!screens.mobile;
  }, [screens]);

  const isMobileAndMd = useMemo(() => {
    return !!(
      (screens.xs || screens.sm || screens.md) &&
      !screens.lg &&
      !screens.xl &&
      !screens.xxl
    );
  }, [screens]);
  const isMobileAndLg = useMemo(() => {
    return !!(
      (screens.xs || screens.sm || screens.md || screens.lg) &&
      !screens.xl &&
      !screens.xxl
    );
  }, [screens]);

  const data = useMemo(
    () => ({
      ...screens,
      isMobile,
      isMobileAndMd,
      isMobileAndLg,
      devicePixelRatio:
        typeof window !== "undefined" ? window.devicePixelRatio : 1,
    }),
    [screens, isMobile, isMobileAndMd, isMobileAndLg]
  );

  return data;
}

export default useBreakpoint;
